import { 
    VStack,
    Pagination,
    Image,
 } from 'rsuite';

function Reader({ book, pageNum, setPageNum, totalPages }) {
    const dir = './'.concat(book, '/p', pageNum, '.jpg');
    return (
        <>
        <VStack alignItems={'center'} justifyContent={'center'}>
            <Pagination
                total={totalPages}
                limit={1}
                prev
                last
                next
                first
                size='md'
                maxButtons={1}
                activePage={pageNum}
                onChangePage={setPageNum}
            />    
            <Image src={dir} height={"40vw"} width={"60vw"} />
        </VStack>    
        </>
    );
};

export default Reader;